import { Component, OnInit } from '@angular/core';
import { NavController } from '@ionic/angular';

@Component({
  selector: 'app-digit-print',
  templateUrl: './digit-print.page.html',
  styleUrls: ['./digit-print.page.scss']
})
export class DigitPrintPage implements OnInit {
  constructor (
    private navCtrl: NavController
  ) { }

  ngOnInit () {
  }

  onClickFingerPrint () {
    this.navCtrl.navigateForward('/face-id');
  }
}
